import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InterceptorInterceptor } from './interceptor.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './login/login.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AgencyComponent } from './agency/agency.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MainDashboardComponent } from './main-dashboard/main-dashboard.component';
import { FilterPipe } from 'src/pipes/filter.pipe';
import { SettingsComponent } from './settings/settings.component';
// import { PdfViewerModule } from 'ng2-pdf-viewer';
import {  CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


// import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SidebarComponent,
    AgencyComponent,
    DashboardComponent,
    FilterPipe,
    MainDashboardComponent,
    SettingsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    // PdfViewerModule
    // SweetAlert2Module
  ],
  providers: [   {
    provide: HTTP_INTERCEPTORS,
    useClass: InterceptorInterceptor,
    multi: true // This allows you to use multiple interceptors
  }],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
  bootstrap: [AppComponent]
})
export class AppModule { }
